/**
 * Which layout the editor is in (the dock, or the compact layout for phones),
 * for the few things inside the panels that differ between them. The shell
 * frame provides it; a panel reads it. Layout is presentation, so it stays out
 * of the engine's stores.
 */
import { createContext, useContext } from "react";
import type { EditorLayout } from "./layout";

export const EditorLayoutContext = createContext<EditorLayout>("desktop");

export function useEditorLayout(): EditorLayout {
  return useContext(EditorLayoutContext);
}
